<div [formGroup]="group">
  <input
    [type]="config.inputType || 'text'"
    [placeholder]="config.placeholder || config.label || config.name"
    [formControlName]="config.name"
  />
</div>
